import { Loader, Modal, Paper, Stack, Text, Image } from "@mantine/core";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
const logoLightSrc = "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/logoLight.png?v=1668237175"
const logoDarkSrc = "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/logoDark.png"

const discount_code = "BOGO-STEAK"
// this was used in 2022 november --> const refParameter = "943EBF20221113SMS1"
// this has now been delegated to the liquid code --> const refParameter = "568264BF20231125SMS1"


function App() {

  const [opened, setOpened] = useState(true)

  useEffect(() => {

    Cookies.set('discount_code', discount_code)
    Cookies.set('ih_discount_app_code', discount_code)
    // this has now been delegated to the liquid code --> Cookies.set('ref', refParameter, { path: '/', domain: '.aikidosteel.com' })
    
    const clearCartaddToCartAddDiscountCode = (variantId, quantity, code) => {
      let popUpFormData = {
        'items': [{
         'id': variantId,
         'quantity': quantity
         }]
       };
       
      fetch("/cart/clear.js", {
        method: 'POST'
      }).then((response) => {
        response.json().then((data) => {
          fetch("/cart/add.js", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(popUpFormData)
          }).then((response) => {
            response.json().then((data) => {
              var promo_code = code;
              //document.cookie = "discount_code=" + promo_code + "; path=/";
              //document.cookie = "ih_discount_app_code=" + promo_code + "; path=/";
              fetch(`/discount/${promo_code}`).then((response) => {
                response.text().then((data) => {
                  window.location = "/cart"
                });
              });
            });
          });
        });
      });
    }

    setTimeout(() => {
      clearCartaddToCartAddDiscountCode(38138627489966, 2, "BOGO-STEAK")
    }, 3000)
/*
    setTimeout(() => {
      window.location.href = "https://aikidosteel.com/cart/clear?return_to=/cart/update?updates[38138627489966]=2"
    }, 3000)
 */   

  }, [])


  return (
    <>
      <Modal overlayOpacity={0} shadow={0} centered style={{background: "#c53531"}} styles={{modal: {background: "#c53531"}}} opened={opened} onClose={()=> {}} withCloseButton={false}>
        <Paper p={20} style={{background: "#c53531"}}>
          <Stack align={"center"} spacing={40}>
            <Image style={{margin: "auto"}} src={logoDarkSrc}></Image>
            <Text size={"xl"} lh={1.35} mb={8} lts={3} color={"black"} align="center">Applying your exclusive</Text>
            <Text size={"xl"} weight={800} mt={-40} color={"#ffd00e"} align="center">VALENTINE'S DAY OFFER...</Text>
            <Loader color={"white"} size={"xl"}></Loader>
          </Stack>
        </Paper>
        
      </Modal>
    </>
  );
}

export default App;
